var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-between mt-3"},[_c('div',{staticClass:"col-md-10 mt-3 pr-5"},[_c('Manual')],1)]),_c('PaymentModalEventWrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }